import React, { useRef } from 'react';
import RichTextEditor from './RichTextEditor';

const BlogPostForm = ({ 
  formData, 
  setFormData, 
  onSubmit, 
  editingPost, 
  uploading,
  imagePreview,
  onImageUpload
}) => {
  const fileInputRef = useRef(null);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-testid="blog-form">
      <h2 className="font-rubik text-2xl font-bold mb-4 text-[#646464]">
        {editingPost ? 'EDIT POST' : 'NEW POST'}
      </h2>
      <form onSubmit={onSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block font-rubik font-medium mb-2">Title *</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              required
              className="w-full px-4 py-2 border rounded font-roboto focus:outline-none focus:border-[#aaae10]"
              data-testid="blog-title-input"
            />
          </div>
          <div>
            <label className="block font-rubik font-medium mb-2">Date *</label>
            <input
              type="text"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              required
              className="w-full px-4 py-2 border rounded font-roboto focus:outline-none focus:border-[#aaae10]"
              placeholder="January 15, 2026"
              data-testid="blog-date-input"
            />
          </div>
        </div>

        <div className="mb-4">
          <label className="block font-rubik font-medium mb-2">Category *</label>
          <input
            type="text"
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            required
            className="w-full px-4 py-2 border rounded font-roboto focus:outline-none focus:border-[#aaae10]"
            placeholder="Sustainability, Conservation, etc."
            data-testid="blog-category-input"
          />
        </div>

        <div className="mb-4">
          <label className="block font-rubik font-medium mb-2">Featured Image</label>
          <div className="flex items-center gap-4">
            <input
              type="file"
              ref={fileInputRef}
              onChange={onImageUpload}
              accept="image/*"
              className="hidden"
            />
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              disabled={uploading}
              className="btn-secondary"
              data-testid="upload-image-button"
            >
              {uploading ? 'Uploading...' : 'Upload Image'}
            </button>
            {imagePreview && (
              <img src={imagePreview} alt="Preview" className="h-20 w-auto rounded border" />
            )}
          </div>
        </div>

        <div className="mb-4">
          <label className="block font-rubik font-medium mb-2">Excerpt *</label>
          <textarea
            value={formData.excerpt}
            onChange={(e) => setFormData({ ...formData, excerpt: e.target.value })}
            required
            rows="3"
            className="w-full px-4 py-2 border rounded font-roboto focus:outline-none focus:border-[#aaae10]"
            placeholder="Short description for the blog list"
            data-testid="blog-excerpt-input"
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block font-rubik font-medium mb-2">Content *</label>
          <RichTextEditor
            content={formData.content}
            onChange={(html) => setFormData({ ...formData, content: html })}
          />
          <p className="mt-2 text-sm text-gray-600">
            Use the toolbar above to format your blog content with rich text features.
          </p>
        </div>

        <div className="mb-4 mt-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={formData.published}
              onChange={(e) => setFormData({ ...formData, published: e.target.checked })}
              className="mr-2"
              data-testid="blog-published-checkbox"
            />
            <span className="font-rubik font-medium">Published</span>
          </label>
        </div>

        <button type="submit" className="btn-primary" data-testid="save-post-button">
          {editingPost ? 'Update Post' : 'Create Post'}
        </button>
      </form>
    </div>
  );
};

export default BlogPostForm;
